import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.4392 9.74C12.2449 9.92825 12.1557 10.2005 12.1999 10.4675L12.8667 14.1575C12.9229 14.4702 12.7909 14.7868 12.5292 14.9675C12.2727 15.155 11.9314 15.1775 11.6517 15.0275L8.32991 13.295C8.21441 13.2335 8.08616 13.2005 7.95491 13.1968H7.75166C7.68116 13.2073 7.61216 13.2297 7.54916 13.2642L4.22666 15.005C4.06241 15.0875 3.87641 15.1168 3.69416 15.0875C3.25016 15.0035 2.95391 14.5805 3.02666 14.1343L3.69416 10.4443C3.73841 10.175 3.64916 9.90125 3.45491 9.71L0.746657 7.085C0.520157 6.86525 0.441407 6.53525 0.544907 6.2375C0.645407 5.9405 0.901907 5.72375 1.21166 5.675L4.93916 5.13425C5.22266 5.105 5.47166 4.9325 5.59916 4.6775L7.24166 1.31C7.28066 1.235 7.33091 1.166 7.39166 1.1075L7.45916 1.055C7.49441 1.016 7.53491 0.98375 7.57991 0.9575L7.66166 0.9275L7.78916 0.875H8.10491C8.38691 0.90425 8.63516 1.073 8.76491 1.325L10.4292 4.6775C10.5492 4.92275 10.7824 5.093 11.0517 5.13425L14.7792 5.675C15.0942 5.72 15.3574 5.9375 15.4617 6.2375C15.5599 6.53825 15.4752 6.86825 15.2442 7.085L12.4392 9.74Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;
